import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Placeholder from 'components/consumer/Placeholder';
const PDPShopTabsBarPlaceholder = t0 => {
  const $ = _c(5);
  const {
    isLayoutRevamp: t1
  } = t0;
  const isLayoutRevamp = t1 === undefined ? false : t1;
  const t2 = !isLayoutRevamp;
  let t3;
  if ($[0] !== isLayoutRevamp || $[1] !== t2) {
    t3 = classNames("!w-full", {
      "!h-[61px]": isLayoutRevamp,
      "!h-[58px]": t2
    });
    $[0] = isLayoutRevamp;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== t3) {
    t4 = <Placeholder type="rect" loading={true} className={t3} />;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
};
PDPShopTabsBarPlaceholder.propTypes = {
  isLayoutRevamp: PropTypes.bool
};
export default PDPShopTabsBarPlaceholder;